<template>
  <v-menu v-model="menuMoreDates" offset-y :close-on-content-click="false" max-width="280" :disabled="loading">
    <template v-slot:activator="{ on, attrs }">
      <v-btn x-small outlined color="#023449" v-bind="attrs" v-on="on" :disabled="loading" class="more-options-btn">
        <v-icon x-small left>mdi-dots-horizontal</v-icon>
        Mais
      </v-btn>
    </template>

    <v-card class="quick-dates-menu">
      <v-card-title class="menu-title">
        <v-icon small color="#023449" class="mr-2">mdi-calendar-clock</v-icon>
        Períodos Rápidos
      </v-card-title>
      <v-divider></v-divider>

      <v-list dense class="date-options-list">
        <date-category
            title="Semanas"
            icon-expanded="mdi-chevron-down"
            icon-collapsed="mdi-chevron-right"
            :expanded="expandedCategory === 'weeks'"
            @toggle="toggleCategory('weeks')"
        >
          <v-list-item @click="selectPeriod('currentWeek')" class="list-item-hover">
            <v-list-item-icon class="mr-3 ml-6">
              <v-icon small color="#023449">mdi-calendar-week</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Semana Atual</v-list-item-title>
              <v-list-item-subtitle class="date-preview">{{ getDatePreview('currentWeek') }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>

          <v-list-item @click="selectPeriod('lastWeek')" class="list-item-hover">
            <v-list-item-icon class="mr-3 ml-6">
              <v-icon small color="#023449">mdi-calendar-week-begin</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Semana Anterior</v-list-item-title>
              <v-list-item-subtitle class="date-preview">{{ getDatePreview('lastWeek') }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </date-category>

        <v-divider class="my-1"></v-divider>

        <date-category
            title="Meses"
            :expanded="expandedCategory === 'months'"
            @toggle="toggleCategory('months')"
        >
          <v-list-item @click="selectPeriod('currentMonth')" class="list-item-hover">
            <v-list-item-icon class="mr-3 ml-6">
              <v-icon small color="#023449">mdi-calendar-month</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Mês Atual</v-list-item-title>
              <v-list-item-subtitle class="date-preview">{{ getDatePreview('currentMonth') }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>

          <v-list-item @click="selectPeriod('lastMonth')" class="list-item-hover">
            <v-list-item-icon class="mr-3 ml-6">
              <v-icon small color="#023449">mdi-calendar-month-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Mês Anterior</v-list-item-title>
              <v-list-item-subtitle class="date-preview">{{ getDatePreview('lastMonth') }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </date-category>

        <v-divider class="my-1"></v-divider>

        <date-category
            title="Trimestres"
            :expanded="expandedCategory === 'quarters'"
            @toggle="toggleCategory('quarters')"
        >
          <v-list-item @click="selectPeriod('currentQuarter')" class="list-item-hover">
            <v-list-item-icon class="mr-3 ml-6">
              <v-icon small color="#023449">mdi-calendar-today</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Trimestre Atual</v-list-item-title>
              <v-list-item-subtitle class="date-preview">{{ getDatePreview('currentQuarter') }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>

          <v-list-item @click="selectPeriod('lastQuarter')" class="list-item-hover">
            <v-list-item-icon class="mr-3 ml-6">
              <v-icon small color="#023449">mdi-calendar-blank</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Trimestre Anterior</v-list-item-title>
              <v-list-item-subtitle class="date-preview">{{ getDatePreview('lastQuarter') }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </date-category>

        <v-divider class="my-1"></v-divider>

        <date-category
            title="Anos"
            :expanded="expandedCategory === 'years'"
            @toggle="toggleCategory('years')"
        >
          <v-list-item @click="selectPeriod('currentYear')" class="list-item-hover">
            <v-list-item-icon class="mr-3 ml-6">
              <v-icon small color="#023449">mdi-calendar</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Ano Atual</v-list-item-title>
              <v-list-item-subtitle class="date-preview">{{ getDatePreview('currentYear') }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>

          <v-list-item @click="selectPeriod('lastYear')" class="list-item-hover">
            <v-list-item-icon class="mr-3 ml-6">
              <v-icon small color="#023449">mdi-calendar-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Ano Anterior</v-list-item-title>
              <v-list-item-subtitle class="date-preview">{{ getDatePreview('lastYear') }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </date-category>
      </v-list>

      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text small color="#023449" @click="menuMoreDates = false">Fechar</v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>
import DateCategory from './DateCategory.vue';

export default {
  name: 'QuickDatesMenu',

  components: { DateCategory },

  props: {
    loading: Boolean
  },

  data() {
    return {
      menuMoreDates: false,
      expandedCategory: null
    };
  },

  methods: {
    toggleCategory(category) {
      this.expandedCategory = this.expandedCategory === category ? null : category;
    },

    selectPeriod(period) {
      this.$emit('select-period', period);
      this.menuMoreDates = false;
    },

    getDatePreview(period) {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      let start, end;

      const getStartOfWeek = (date) => {
        const d = new Date(date);
        const day = d.getDay();
        const diff = d.getDate() - day;
        return new Date(d.setDate(diff));
      };

      const getEndOfWeek = (date) => {
        const d = new Date(date);
        const day = d.getDay();
        const diff = d.getDate() + (6 - day);
        return new Date(d.setDate(diff));
      };

      const getStartOfMonth = (date) => new Date(date.getFullYear(), date.getMonth(), 1);
      const getEndOfMonth = (date) => new Date(date.getFullYear(), date.getMonth() + 1, 0);

      const getQuarter = (date) => Math.floor(date.getMonth() / 3);
      const getStartOfQuarter = (date) => {
        const quarter = getQuarter(date);
        return new Date(date.getFullYear(), quarter * 3, 1);
      };
      const getEndOfQuarter = (date) => {
        const quarter = getQuarter(date);
        return new Date(date.getFullYear(), quarter * 3 + 3, 0);
      };

      switch (period) {
        case 'currentWeek':
          start = getStartOfWeek(today);
          end = getEndOfWeek(today);
          break;
        case 'lastWeek': {
          const lastWeekDate = new Date(today);
          lastWeekDate.setDate(lastWeekDate.getDate() - 7);
          start = getStartOfWeek(lastWeekDate);
          end = getEndOfWeek(lastWeekDate);
          break;
        }
        case 'currentMonth':
          start = getStartOfMonth(today);
          end = getEndOfMonth(today);
          break;
        case 'lastMonth': {
          const lastMonthDate = new Date(today.getFullYear(), today.getMonth() - 1, 1);
          start = getStartOfMonth(lastMonthDate);
          end = getEndOfMonth(lastMonthDate);
          break;
        }
        case 'currentQuarter':
          start = getStartOfQuarter(today);
          end = getEndOfQuarter(today);
          break;
        case 'lastQuarter': {
          const lastQuarterDate = new Date(today);
          lastQuarterDate.setMonth(lastQuarterDate.getMonth() - 3);
          start = getStartOfQuarter(lastQuarterDate);
          end = getEndOfQuarter(lastQuarterDate);
          break;
        }
        case 'currentYear':
          start = new Date(today.getFullYear(), 0, 1);
          end = new Date(today.getFullYear(), 11, 31);
          break;
        case 'lastYear':
          start = new Date(today.getFullYear() - 1, 0, 1);
          end = new Date(today.getFullYear() - 1, 11, 31);
          break;
        default:
          return '';
      }

      return `${this.formatDate(start)} - ${this.formatDate(end)}`;
    },

    formatDate(date) {
      if (!date) return '';
      const dateStr = date.toISOString().split('T')[0];
      const d = new Date(dateStr + 'T00:00:00');
      if (isNaN(d)) return '';
      return d.toLocaleDateString('pt-BR');
    }
  }
};
</script>

<style scoped>
.more-options-btn {
  flex: 1;
  min-width: 65px;
}

.quick-dates-menu {
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 10px 25px rgba(2, 52, 73, 0.15);
  border: 1px solid #e5e7eb;
  padding-bottom: 24px;
}

.menu-title {
  padding: 20px 24px !important;
  font-size: 0.938rem;
  font-weight: 700;
  color: #023449;
  background: linear-gradient(135deg, #f9fafb 0%, #ffffff 100%);
  border-bottom: 2px solid #e5e7eb;
}

.date-options-list {
  padding: 0;
  max-height: 420px;
  overflow-y: auto;
}

.date-options-list::-webkit-scrollbar {
  width: 8px;
}

.date-options-list::-webkit-scrollbar-track {
  background: #f9fafb;
}

.date-options-list::-webkit-scrollbar-thumb {
  background: #d1d5db;
  border-radius: 4px;
}

.list-item-hover {
  transition: all 0.2s ease;
  cursor: pointer;
  padding: 12px 16px !important;
  border-bottom: 1px solid #f9fafb;
}

.list-item-hover:hover {
  background-color: #f0f9ff !important;
}

.list-item-hover >>> .v-list-item__icon {
  min-width: 36px !important;
}

.list-item-hover >>> .v-list-item__title {
  font-size: 0.875rem;
  font-weight: 600;
  color: #1f2937;
}

.date-preview {
  font-size: 0.75rem !important;
  color: #6b7280 !important;
  margin-top: 4px !important;
  font-weight: 500 !important;
}
</style>